import { render, staticRenderFns } from "./TwoTwelve.vue?vue&type=template&id=560ffd9a&scoped=true&"
var script = {}
import style0 from "./TwoTwelve.vue?vue&type=style&index=0&id=560ffd9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560ffd9a",
  null
  
)

export default component.exports